import Form from 'react-bootstrap/Form'

export default function Label({ children, controlId = null, required = false }) {
	return <Form.Label htmlFor={controlId}>
		{children}{' '}
		{required && <span className="required">*</span>}
	</Form.Label>
}
